export enum CybermetrieEnum {
  CATEGORIE_GESTION_CARTE = 'Gestion carte de credit',
  CATEGORIE_TRANSACTION = 'Transaction',
  ACTION_CLIC = 'Clic',
  ACTION_DEBUTE = 'debute',
  ACTION_ETAPE = 'etape-2',
  ACTION_COMPLETE = 'complete',
  ACTION_AJOUTER = 'ajouter',
  ACTION_AFFICHAGE = 'Affichage',
  ACTION_EOF = 'eof',
  ACTION_ERREUR_UTILISATEUR = 'erreur utilisateur',
  ACTION_ERREUR_TECHNIQUE = 'erreur technique',
  LABEL_MODIFIER_COORDONNEES = 'modifier coordonnees - carte de credit',
  LABEL_PLUSIEURS_COURRIELS = 'modifier coordonnees - carte de credit - plusieurs courriels',
  LABEL_BOUTON_MODIFIER_ADRESSE = 'modifier coordonnees - carte de credit - modifier - adresse principale',
  LABEL_BOUTON_MODIFIER_TELEPHONE = 'modifier coordonnees - carte de credit - modifier - telephone',
  LABEL_BOUTON_MODIFIER_COURRIEL = 'modifier coordonnees - carte de credit - modifier - courriel',
  LABEL_MODIFIER_ADRESSE = 'trx - modifier coordonnees - carte de credit|adresse principale',
  LABEL_MODIFIER_TELEPHONE = 'trx - modifier coordonnees - carte de credit|telephone',
  LABEL_MODIFIER_COURRIEL = 'trx - modifier coordonnees - carte de credit|courriel',
  LABEL_MODIFIER_INFOS = 'trx - modifier coordonnees - carte de credit|',
  LABEL_MODIFIER_VALIDATION = 'modifier coordonnees - carte de credit - modifier validation ',
  LABEL_INFOS_TOTAL = 'trx - modifier coordonnees - carte de credit',
  EMPLOYEUR = 'employeur',
  SECONDAIRE = 'secondaire',
  UNE_CARTE_CREDIT = '1 carte',
  PLUSIEURS_CARTES_CREDIT = 'plusieurs cartes',
  AUCUNE_CARTE_CREDIT = 'aucune carte de crédit',
  MESSAGE_ERREUR = 'messageErreur',
  EXTRA_ATTRIBUT = 'extraAttribut',
  OUI = 'oui',
  NON = 'non',
}
